import { Injectable } from '@angular/core';
import { DataService } from 'services/data.service';
import { Http } from '@angular/http';
import { SignMessRequests } from 'domain-models/SignMessRequests';
import { environment } from '../../environments/environment';

@Injectable()
export class SignMessRequestsService extends DataService<SignMessRequests> {
	constructor(http: Http) {
		super(environment.host + 'SignMessRequests', http);
	}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/services/signMessRequests/sign-mess-requests.service.ts